import { EventEmitter, Directive, Input, Output, HostBinding, HostListener, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class NgxLongPress2Directive {
    constructor() {
        this.delay = 50;
        this.lapsedTime = 0; // used for onLongPressing event
        this.minTime = 500; // used for onLongPress event
        this.maxTime = 2000; // used for onReleasePressing event
        // tslint:disable-next-line:no-output-on-prefix
        this.onLongPress = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onLongPressing = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onReleasePressing = new EventEmitter();
    }
    get press() {
        return this.pressing;
    }
    get longPress() {
        return this.longPressing;
    }
    onMouseDown(event) {
        this.pressing = true;
        this.longPressing = false;
        this.timeout = setTimeout(() => {
            this.longPressing = true;
            this.onLongPress.emit(event);
            this.interval = setInterval(() => {
                this.onLongPressing.emit(this.lapsedTime);
                if (this.lapsedTime < this.maxTime) {
                    this.lapsedTime += this.delay;
                }
                else {
                    this.end();
                }
            }, this.delay);
        }, this.minTime);
    }
    endPress() {
        this.end();
    }
    end() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
        this.longPressing = false;
        this.pressing = false;
        this.lapsedTime = 0;
        this.onReleasePressing.next();
    }
}
NgxLongPress2Directive.ɵfac = function NgxLongPress2Directive_Factory(t) { return new (t || NgxLongPress2Directive)(); };
NgxLongPress2Directive.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxLongPress2Directive, selectors: [["", "ngxLongPress2", ""]], hostVars: 4, hostBindings: function NgxLongPress2Directive_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("touchstart", function NgxLongPress2Directive_touchstart_HostBindingHandler($event) { return ctx.onMouseDown($event); })("mousedown", function NgxLongPress2Directive_mousedown_HostBindingHandler($event) { return ctx.onMouseDown($event); })("touchend", function NgxLongPress2Directive_touchend_HostBindingHandler() { return ctx.endPress(); })("mouseup", function NgxLongPress2Directive_mouseup_HostBindingHandler() { return ctx.endPress(); })("mouseleave", function NgxLongPress2Directive_mouseleave_HostBindingHandler() { return ctx.endPress(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("press", ctx.press)("longpress", ctx.longPress);
    } }, inputs: { minTime: "minTime", maxTime: "maxTime" }, outputs: { onLongPress: "onLongPress", onLongPressing: "onLongPressing", onReleasePressing: "onReleasePressing" } });
NgxLongPress2Directive.propDecorators = {
    minTime: [{ type: Input }],
    maxTime: [{ type: Input }],
    onLongPress: [{ type: Output }],
    onLongPressing: [{ type: Output }],
    onReleasePressing: [{ type: Output }],
    press: [{ type: HostBinding, args: ['class.press',] }],
    longPress: [{ type: HostBinding, args: ['class.longpress',] }],
    onMouseDown: [{ type: HostListener, args: ['touchstart', ['$event'],] }, { type: HostListener, args: ['mousedown', ['$event'],] }],
    endPress: [{ type: HostListener, args: ['touchend',] }, { type: HostListener, args: ['mouseup',] }, { type: HostListener, args: ['mouseleave',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxLongPress2Directive, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[ngxLongPress2]'
            }]
    }], function () { return []; }, { minTime: [{
            type: Input
        }], maxTime: [{
            type: Input
        }], onLongPress: [{
            type: Output
        }], onLongPressing: [{
            type: Output
        }], onReleasePressing: [{
            type: Output
        }], press: [{
            type: HostBinding,
            args: ['class.press']
        }], longPress: [{
            type: HostBinding,
            args: ['class.longpress']
        }], onMouseDown: [{
            type: HostListener,
            args: ['touchstart', ['$event']]
        }, {
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], endPress: [{
            type: HostListener,
            args: ['touchend']
        }, {
            type: HostListener,
            args: ['mouseup']
        }, {
            type: HostListener,
            args: ['mouseleave']
        }] }); })();

class NgxLongPress2Module {
}
NgxLongPress2Module.ɵfac = function NgxLongPress2Module_Factory(t) { return new (t || NgxLongPress2Module)(); };
NgxLongPress2Module.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxLongPress2Module });
NgxLongPress2Module.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxLongPress2Module, { declarations: [NgxLongPress2Directive], exports: [NgxLongPress2Directive] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxLongPress2Module, [{
        type: NgModule,
        args: [{
                declarations: [NgxLongPress2Directive],
                exports: [NgxLongPress2Directive]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-long-press2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxLongPress2Directive, NgxLongPress2Module };

//# sourceMappingURL=ngx-long-press2.js.map